import React from "react";
import useNavigateToProfile from "../../hooks/useNavigateToProfile";
import UserPlaceHolderImg from "../../assets/img/common/user-placeholder-img.png";

const UserSubtitle = ({ creator }) => {
  const { title_rank, role, university_college, location, email } =
    creator ?? {};
  if (role === "applicant") {
    if (university_college) {
      return (
        <p className="text-[15px] text-custom-gray-700 truncate">
          <span className="font-medium text-custom-gray-900">{title_rank}</span>{" "}
          at{" "}
          <span className="font-medium text-custom-gray-900">
            {university_college}
          </span>
        </p>
      );
    }
    return (
      <span className="text-[15px] font-medium text-custom-gray-800">
        {title_rank}
      </span>
    );
  } else {
    return (
      <span className="text-[15px] font-medium text-custom-gray-800">
        {location || email}
      </span>
    );
  }
};
const UserCard = ({ userData }) => {
  const { navigateToProfile } = useNavigateToProfile();
  const { role, _id, images, firstname, lastname, fundername, skills } =
    userData ?? {};

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        navigateToProfile(_id, role);
      }}
      className={`w-full flex justify-between items-start border border-white/20 backdrop-blur-sm rounded-xl bg-white/60 hover:bg-white/80 hover:border-primary/30 hover:shadow-lg transition-all duration-300 p-3 cursor-pointer`}
    >
      <div className="hidden lg:flex items-start cursor-pointer overflow-hidden">
        <span className=" rounded-lg overflow-hidden flex justify-center items-center cursor-pointer h-28 w-28 min-w-[7rem] ">
          <img
            src={images?.profile ?? UserPlaceHolderImg}
            alt={"user-img"}
            className="transition-all duration-300 hover:scale-110 w-full h-full"
          />
        </span>
        <div className="flex flex-col ml-2 justify-between h-28 overflow-hidden">
          <div className="flex flex-col overflow-hidden">
            <span className="font-semibold text-lg md:text-xl truncate">
              {fundername || firstname + " " + lastname}
            </span>
            <UserSubtitle creator={userData} />
          </div>
          {/* ---- skills --- */}
          {skills?.length ? (
            <div className="flex items-center flex-wrap gap-3 mt-2">
              {skills?.slice(0, 3)?.map((item, index) => (
                <span
                  key={index}
                  className="py-1 px-2 rounded-3xl bg-slate-200 text-slate-700 text-xs"
                >
                  {item?.text}
                </span>
              ))}
            </div>
          ) : null}
        </div>
      </div>

      {/* -------- mobile -------- */}
      <div className="lg:hidden w-full flex flex-col">
        <div className="flex items-start cursor-pointer">
          <span className=" rounded-lg overflow-hidden flex justify-center items-center cursor-pointer h-16 w-16 sm:w-20 sm:h-20 min-w-[4rem] sm:min-w-[5rem]">
            <img
              src={images?.profile ?? UserPlaceHolderImg}
              alt={"user-img"}
              className="transition-all duration-300 hover:scale-110 w-full h-full"
            />
          </span>
          <div className="flex flex-col ml-2 overflow-hidden">
            <span className="font-semibold text-lg md:text-xl truncate">
              {fundername || firstname + " " + lastname}
            </span>
            <UserSubtitle creator={userData} />
          </div>
        </div>
        {/* ---- skills --- */}
        {skills?.length ? (
          <div className="flex items-center flex-wrap gap-3 mt-2">
            {skills?.slice(0, 3)?.map((item, index) => (
              <span
                key={index}
                className="py-1 px-2 rounded-3xl bg-slate-200 text-slate-700 text-xs"
              >
                {item?.text}
              </span>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default UserCard;
